import type { estypes } from '@elastic/elasticsearch'

export const superSliteMetadataMapping = {
  iconColor: {
    type: 'keyword',
    index: false,
  },
  iconShape: {
    type: 'keyword',
    index: false,
  },
  reviewState: {
    type: 'keyword',
    index: false,
  },
  isArchived: {
    type: 'boolean',
    index: false,
  },
  isTemplate: {
    type: 'boolean',
    index: false,
  },
  collectionMetadata: {
    type: 'binary',
  },
  linkedNoteIds: {
    type: 'keyword',
    index: false,
  },
  ownerId: {
    type: 'keyword',
    index: false,
  },
  ownerUserGroupId: {
    type: 'keyword',
    index: false,
  },
  canonicalKind: {
    type: 'keyword',
  },
  recentActivities: {
    properties: {
      type: {
        type: 'keyword',
        index: false,
      },
      userId: {
        type: 'keyword',
        index: false,
      },
      createdAt: {
        type: 'date',
        index: false,
      },
      metadata: {
        type: 'binary',
      },
    },
  },
} satisfies Record<string, estypes.MappingProperty>
